import React, { Component } from 'react';
import AccessContainer from '../../access/AccessContainer';
import { RootState } from '../../../redux/store';
import { ConnectedProps } from 'react-redux/es/exports';
import { connect } from 'react-redux';
import { AccessBase } from '../../../domain/access/BaseAccess';
import { changeQuery } from 'redux/actions/QueryActions';
import RoleHelper from '../../../RoleHelper';

class QueryAccessComponent extends Component<Props> {
  render() {
    const {
      query: { queryVariable },
    } = this.props;
    const access: AccessBase = { permission: queryVariable.permission, collaborators: queryVariable.collaborators };
    return <AccessContainer access={access} changeAccess={this.changeBasicVariableAccess} disabled={!RoleHelper.canManage('EnrichmentQuery')} />;
  }

  private changeBasicVariableAccess = (access: AccessBase) => {
    const {
      query: { queryVariable },
      changeQuery,
    } = this.props;
    queryVariable.permission = access.permission;
    queryVariable.collaborators = access.collaborators;
    changeQuery(queryVariable);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  query: state.query,
});
const mapDispatchToProps = { changeQuery };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(QueryAccessComponent);
